<template>
  <el-checkbox-group class="list" v-model="checkedList" @change="onCheckChange">
    <el-checkbox
      class="item"
      v-for="(c, i) in list"
      :key="'itemm' + i"
      :label="c[labelKey || 'id']"
    >
      <div class="row0">{{ c.license }}</div>
      <div class="row1">{{ c.driver }}</div>
    </el-checkbox>
  </el-checkbox-group>
</template>

<script>
export default {
  name: "CarList",
  props: {
    list: Array,
    labelKey: String,
    checkedIds: Array,
  },
  data() {
    return {
      checkedList: this.checkedIds || [],
    };
  },
  watch: {
    checkedIds: {
      deep: true,
      handler(newVal) {
        this.checkedList = newVal;
      },
    },
  },
  methods: {
    onCheckChange(v) {
      // console.log('onCheckChange', v);
      // console.log('checkedIds', this.checkedIds)
      this.$emit("onCheckChange", v);
    },
    clearChecked() {
      this.checkedList = [];
    },
  },
};
</script>

<style lang="less" scoped>
.list {
  display: flex;
  flex-wrap: wrap;

  .item {
    background: #fafafa;
    border-radius: 6px;
    border: 1px solid #fafafa;
    position: relative;
    margin: 0 15px 15px 0;
    position: relative;
    width: 136px;
    box-sizing: border-box;

    &:nth-child(6n) {
      margin-right: 0;
    }

    &.is-checked {
      border-color: #409eff;
    }

    /deep/ .el-checkbox__input {
      position: absolute;
      right: 15px;
      top: 15px;
    }

    /deep/ .el-checkbox__label {
      padding: 0;
      display: block;
    }

    .row0 {
      padding: 15px;
      height: 14px;
      font-size: 14px;
      color: #303133;
      border-bottom: 1px solid #ebeef5;
    }

    .row1 {
      padding: 10px 15px;
      height: 14px;
      font-size: 14px;
      color: #909399;
    }
  }
}
</style>
